import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import AddModals from '../../components/modals/addModals';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { isAuxFormatter, natureFormatter, natureTextFormatter } from '../../components/formatters/defFormatter';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { Space, Input, Tag, Button, Tabs, Checkbox } from 'antd';


import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';
import AccountForm from './accountForm';




function AuxAccount(props) {

  let { } = props;


  const { userData, settingData, devData, refData, api, companyId, parentAccountData, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isChart: 'false', companyId });

  const [showModal, setShowModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const table = 'account';
  const title = 'account';


  // Account Options
  const accountOptions = parentAccountData?.map(item => ({
    value: item.id,
    label: `${item.accountId} ${item.english}`,
  }));
  const loadAccountOptions = (inputValue, callback) => {
    const filteredOptions = inputValue ? accountOptions.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];

    callback(filteredOptions);
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['parentAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);


  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }




  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        name: item.english,
        Type: item.type,
        group: item.group ? item.group.name : null, // Add group information if available
        isAux: item.isAux, // Assuming this field exists in the data
        Nature: natureTextFormatter(item.isDebit, item),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };


  let newColumnDefs = useMemo(() => [
    { title: contentLanguages.Sys, dataIndex: 'id', width: '6%' },
    { title: contentLanguages.ID, dataIndex: 'id', width: '10%', sorter: (a, b) => a.age - b.age, render: (id, record) => (record.parent?.accountId + '.' + record.accountId) },
    { title: contentLanguages.Name, dataIndex: 'english' },
    { title: contentLanguages.Type, dataIndex: 'type' },
    { title: contentLanguages.Group, dataIndex: 'group', render: (group) => (group?.name) },
    { title: contentLanguages.Auxiliary, dataIndex: 'isAux', width: '8%', render: isAuxFormatter },
    { title: contentLanguages.Nature, dataIndex: 'isDebit', width: '8%', render: natureFormatter },
  ]);

  useEffect(() => {

    newColumnDefs.push(
      {
        title: contentLanguages.Edt,
        width: '5%',
        render: (_, record) => (
          <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => openModal(record)} />
        ),
      },
      {
        title: contentLanguages.Void,
        width: '5%',
        render: (_, record) => (record.isActive ? (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
        ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
        )
      }
    );

    setColumnDefs(newColumnDefs);

  }, []);




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>

          <Row className='g-1 mb-3'>
            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={3}>
              <AsyncSelect
                styles={{
                  control: (base) => ({
                    ...base,
                    height: '31px', // Adjust the height for "sm"
                    minHeight: '31px', // Ensures consistency
                    fontSize: '0.84rem', // Bootstrap's small font size
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    marginTop: -2,
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    marginTop: -2,
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    marginTop: -2,
                  }),
                }}
                cacheOptions
                isClearable={true}
                loadOptions={loadAccountOptions}
                defaultOptions={[]}
                onChange={(e) => handleSelectChange(e, 'parentId')}
                value={accountOptions?.find(option => option.value === filter.parentId)}
                noOptionsMessage={() => 'type to view'}
                placeholder='Select Parent ...'
              />
            </Col>


            <Col md={5}>

            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => openModal(null)}>Add</Button>
            </Col>

          </Row>





          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id }}
          />


          <AccountForm
            showModal={showModal}
            toggleModal={openModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
          />




        </>
      }

    </div>
  )
}

export default AuxAccount;
